"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmInputPhone = void 0;
const react_1 = __importStar(require("react"));
const Icon_1 = require("../Icon");
const input_1 = require("../FieldControl/input");
const button_1 = require("../FieldControl/button");
const InputText_1 = require("../InputText");
const utils_1 = require("./utils");
const ListCountriesDDI_1 = require("./ListCountriesDDI");
const useCombobox_1 = require("./useCombobox");
const label_1 = require("../FieldControl/label");
const caption_1 = require("../FieldControl/caption");
exports.SmInputPhone = (0, react_1.forwardRef)((_a, ref) => {
    var _b;
    var { id, label, message, sizeInput, state, disabled, icon, iconLabel, labelIcon, onIconClick, onSelect, onClear, selectOnly = false } = _a, props = __rest(_a, ["id", "label", "message", "sizeInput", "state", "disabled", "icon", "iconLabel", "labelIcon", "onIconClick", "onSelect", "onClear", "selectOnly"]);
    const [ddiOptions, setDdiOptions] = (0, react_1.useState)([]);
    const [selectedFlag, setSelectedFlag] = (0, react_1.useState)(null);
    const { phoneValue, isOpen, listitemRef, maskRef, listboxRef, comboboxRef, onMaskChange, onComboboxClick, onComboboxKeyDown, onComboboxChange, onComboboxBlur, onItemClick, clearValue, } = (0, useCombobox_1.useCombobox)(ref, ddiOptions, selectOnly, {
        ddi: props.ddi || '',
        phone: props.phone || '',
    });
    const listId = (0, react_1.useMemo)(() => label === null || label === void 0 ? void 0 : label.toLowerCase().replace('', '-'), [label]);
    (0, react_1.useImperativeHandle)(ref, () => comboboxRef.current);
    const inputClassnames = (0, utils_1.getClassNames)(sizeInput, state);
    const fetchCountriesData = () => __awaiter(void 0, void 0, void 0, function* () {
        const ddiOptionsData = yield (0, utils_1.getCountryData)();
        setDdiOptions(ddiOptionsData);
    });
    const fetchCurrentCountryData = () => __awaiter(void 0, void 0, void 0, function* () {
        const data = yield (0, utils_1.getCurrentCountry)();
        if (data) {
            setSelectedFlag(data);
        }
    });
    const handleSelectFlag = (selected) => {
        if (!selected.disabled) {
            onItemClick(selected.value);
            setSelectedFlag({
                phoneCode: selected.value,
                label: selected.label,
                selectedFlag: selected.flag,
            });
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(selected.value);
        }
    };
    (0, react_1.useEffect)(() => {
        fetchCountriesData();
        if (!selectedFlag) {
            fetchCurrentCountryData();
        }
    }, []);
    const valueDDI = ((_b = props.ddi) === null || _b === void 0 ? void 0 : _b.length) && props.ddi.length > 4
        ? `${props.ddi.substring(0, 3)}...`
        : props.ddi;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: inputClassnames },
            react_1.default.createElement("div", { "data-testid": "inputPhone-container", className: `c-control -text flag -${state}` },
                react_1.default.createElement(label_1.SmLabel, { label: label, labelIcon: labelIcon }),
                react_1.default.createElement("span", { className: "flag-icon", style: {
                        backgroundImage: ` url(${selectedFlag === null || selectedFlag === void 0 ? void 0 : selectedFlag.selectedFlag}) `,
                    } }),
                react_1.default.createElement(input_1.SmInputTemplate, Object.assign({}, props, { id: id, ref: comboboxRef, type: "text", message: message, disabled: disabled, role: "combobox", "aria-haspopup": "listbox", "aria-autocomplete": "list", "aria-expanded": isOpen, "aria-controls": `${listId}-listbox`, className: "flag-country", placeholder: "+XXX", value: valueDDI, readOnly: selectOnly, onClick: (e) => {
                        var _a;
                        onComboboxClick();
                        (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
                    }, onChange: (e) => {
                        onComboboxChange(e);
                    }, onKeyDown: (e) => {
                        var _a;
                        onComboboxKeyDown(e);
                        (_a = props.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(props, e);
                    }, onBlur: (e) => {
                        var _a;
                        onComboboxBlur();
                        (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, e);
                    } })),
                react_1.default.createElement(button_1.SmInputButtonTemplate, { "aria-expanded": isOpen, "aria-controls": `${listId}-listbox`, disabled: disabled, className: "-country-flag", onClick: (e) => {
                        onComboboxClick();
                        onIconClick === null || onIconClick === void 0 ? void 0 : onIconClick(e);
                    }, title: iconLabel, icon: icon !== null && icon !== void 0 ? icon : react_1.default.createElement(Icon_1.SmIcon, { name: `arrow_drop_${isOpen ? 'up' : 'down'}` }), onBlur: () => {
                        onComboboxBlur();
                    } }),
                react_1.default.createElement("ul", { id: `${listId}-listbox`, className: `c-select flag-country-list ${isOpen ? '-expanded' : ''}`, role: "listbox", ref: listboxRef },
                    react_1.default.createElement(ListCountriesDDI_1.ListCountriesDDI, { value: props.ddi || '', items: ddiOptions, onSelectItem: handleSelectFlag, listitemRef: listitemRef })),
                react_1.default.createElement(caption_1.SmCaption, { id: id, message: message, state: state })),
            react_1.default.createElement("div", { className: "input-phone" },
                react_1.default.createElement(InputText_1.SmInputText, { state: state, srOnly: true, ref: maskRef, value: phoneValue === null || phoneValue === void 0 ? void 0 : phoneValue.phone, disabled: disabled, placeholder: "(00) 00000 0000", onChange: (e) => {
                        var _a, _b;
                        onMaskChange(e);
                        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, (_b = phoneValue === null || phoneValue === void 0 ? void 0 : phoneValue.phone) !== null && _b !== void 0 ? _b : '', e);
                    }, onClear: (e) => {
                        clearValue();
                        setSelectedFlag(null);
                        onClear === null || onClear === void 0 ? void 0 : onClear(e);
                    }, className: "phone-country" })))));
});
//# sourceMappingURL=index.js.map